import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import getStrings from "../localization/getStrings";

const useLang = (screen: string) => {
	const [strings, setStrings] = useState<any>(undefined);
	const lang = useSelector((state: any) => state.langReducer.lang);

	useEffect(() => {
		const strings = getStrings(screen, lang);
		setStrings(strings);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lang]);
	return { strings, lang };
};

export default useLang;
